// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-change-password-tooltip-item {
  display: block;
  margin-top: 10px;
  color: var(--fi-color-green);
}
fi-change-password-tooltip-item.error {
  color: var(--fi-color-red);
}
fi-change-password-tooltip-item .fa {
  color: inherit;
}

.fi-change-password-tooltip-item-icon {
  min-width: 15px;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/change-password-tooltip/change-password-tooltip-item.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;EAEA,4BAAA;AAAJ;AAEI;EACI,0BAAA;AAAR;AAGI;EACI,cAAA;AADR;;AAKA;EACI,eAAA;AAFJ","sourcesContent":["fi-change-password-tooltip-item {\r\n    display: block;\r\n    margin-top: 10px;\r\n\r\n    color: var(--fi-color-green);\r\n\r\n    &.error {\r\n        color: var(--fi-color-red);\r\n    }\r\n\r\n    .fa {\r\n        color: inherit;\r\n    }\r\n}\r\n\r\n.fi-change-password-tooltip-item-icon {\r\n    min-width: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
